import React from "react";
import {Button, Col, Form, FormGroup, Row} from "reactstrap";
import NombreInput from "./NombreInput";
import Icons from '../Icons';
import UploadInput from "./UploadInput";
import {colorData} from "./iColorData";
import {removeFileInLocaleStorage} from '../RenderDT';
import {withTranslation} from "react-i18next";
import {createItems} from "tunnel-commande/src/components/cart/CartAction";
import {getShopInfosInStorage} from "tunnel-commande/src/components/cart/ShopInfos";
import Modal from 'react-responsive-modal';
import axios from "axios";
import PriceArticle from "./PriceArticle";
import moment from "moment";
import {withHostApi} from "../../contexts/HostApiContext";
import ColorsTextile from "./ColorsTextile";
import ModalControl from "./ModalControl";
import ModalDimensionsNotSave from './ModalDimensionsNotSave';

interface SmallOrderTableState {
  marquageId: number;
  quantite: number;
  dimensions: any;
  dimensionsValides: boolean;
  price: number;
  prixTotal: number;
  file: any;
  creationId: string;
  dateLivraison: string;
  disabled: boolean;
  unlockNbVisuels: boolean;
  unlockDimensions: boolean;
  loadingFile: boolean;
  openZoom: boolean;
  isMobile: boolean;
  quantiteAjoutee: number;
  contentCaracteristiques: '';
  openPopover: boolean;
  articleData: any;
  article_id: number;
  videosFichiers: any;
  openVideo: boolean;
  defaultPrice: boolean;
  videoOpenId: string;
  fileInfos?: fileInfos;
  openModalControl: boolean;
  dpiWindow: number;
  colorData?: colorData;
  contourColor: string;
  showModalTarifs?: boolean;
  dimensionsUpdateNotSave?: boolean;
  openModalDimensionsNotSave: boolean;
  openModalSwitch: boolean;
}

export interface fileInfos {
  UniversalImageToTiff?: boolean
  dimensionsCM?: {largeur?: number, hauteur?: number, ratio?: number}
  finesse?: string
  miniature?: string
}

class SmallOrderTable extends React.Component<any, SmallOrderTableState> {
  private readonly quantiteMin: any = null;
  private readonly acceptMultipleFiles: boolean = false;
  private timeoutId: any;
  private typeTransfer: string;
  private contourPx: number;
  private lng: string;
  private _isMounted : boolean;
  private readonly dimensions: any = null;
  private readonly surfaceSwitchMarquage: number = 0;

  private readonly DTF_ID: number = 488223;

  constructor(props: any) {
    super(props);

    this.dimensions = getShopInfosInStorage() ?  getShopInfosInStorage().dimensionsVisuel : {};
    this.handleOnFormSubmit = this.handleOnFormSubmit.bind(this);
    this.handleOnFormChange = this.handleOnFormChange.bind(this);
    this.setDimensions = this.setDimensions.bind(this);
    this.getFileInfos = this.getFileInfos.bind(this);
    this.onUploadFile = this.onUploadFile.bind(this);
    this.onUploadFileLoading = this.onUploadFileLoading.bind(this);
    this.onDeleteFile = this.onDeleteFile.bind(this);
    this.onUnlockNombreVisuels = this.onUnlockNombreVisuels.bind(this);
    this.onUnlockDimensions = this.onUnlockDimensions.bind(this);
    this.handleOnAddCartBtnClick = this.handleOnAddCartBtnClick.bind(this);
    this.scrollToId = this.scrollToId.bind(this);
    this.setPopoverOpen = this.setPopoverOpen.bind(this);
    this.pageClick = this.pageClick.bind(this);
    this.handleOnPriceChange = this.handleOnPriceChange.bind(this);
    this.setColorsData = this.setColorsData.bind(this);
    this.onOpenModalSwitch = this.onOpenModalSwitch.bind(this);

    this.typeTransfer = this.setTransfert(this.props.product);
    this.contourPx = 0;

    this.surfaceSwitchMarquage = getShopInfosInStorage()?.dimensionsVisuel?.surfaceSwitchMarquage ?? 34900;

    this.state = {
      marquageId: 0,
      quantite: 0,
      dimensions: {l: 0, h: 0},
      price: 0,
      prixTotal: 0,
      file: null,
      creationId: "",
      dateLivraison: "",
      dimensionsValides: false,
      disabled: false,
      unlockNbVisuels: false,
      unlockDimensions: false,
      loadingFile: false,
      openZoom: false,
      openVideo: false,
      isMobile: false,
      contentCaracteristiques: '',
      openPopover: false,
      articleData: {},
      quantiteAjoutee: 0,
      article_id: this.setArticleId(this.props.product),
      videoOpenId: '',
      defaultPrice: true,
      videosFichiers: null,
      openModalControl: false,
      dpiWindow: 96,
      contourColor: 'transparent',
      openModalDimensionsNotSave: false,
      openModalSwitch: false
    };
    this.quantiteMin = getShopInfosInStorage() ? getShopInfosInStorage().quantiteMin : 10;
    this.acceptMultipleFiles = getShopInfosInStorage() && getShopInfosInStorage().multiple_files ? getShopInfosInStorage().multiple_files : false;
    this.timeoutId = null;
    this.lng = this.props.i18n.language;
    this._isMounted = false;
  }

  private playlistFilter(lang: string, allVideos:any, tag: string) {
    const playListIdFR = "PLEa8iBAPfwdO066bpDqsEbM0CYBI_SAwx";
    const playListIdEN = "PLEa8iBAPfwdPVYD8uQzzaTMjYimrJ17bi";
    const selectedPlayList = lang && lang == 'fr' ? playListIdFR : playListIdEN;
    const videosFichiers: any[] = [];

    if(allVideos?.playlists && allVideos.playlists.length > 0 ) {
      allVideos.playlists.forEach((playlist: any) =>{
        if(playlist.id == selectedPlayList) {
          playlist.videos.forEach((video: any) => {
            let hasFichier = false;
            let hasFicheProduit = false;
            video.snippet?.tags.map((tag: string) => {
              if (tag == 'Fichiers') {
                hasFichier = true;
              }
              if (tag == 'PageProduit') {
                hasFicheProduit = true;
              }
            });
            if(hasFichier && hasFicheProduit ) {
              videosFichiers.push(video);
            }
          });
        }
      });
      if(this.state.videosFichiers !== videosFichiers) {
        this.setState({
          videosFichiers: videosFichiers
        });
    }
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.lng = this.props.i18n.language;
    this.checkIfMobile();
    window.addEventListener("resize", () => {
      this.checkIfMobile();
      if (!this.state.isMobile) {
        this.scrollToId('', true);
      }
    });
    window.addEventListener("click", this.pageClick, false);
    if(this.acceptMultipleFiles) {
      this.loadHtml(this.lng, 'preparer-mon-fichier');
    } else {
      this.loadHtml(this.lng, 'preparer-mon-fichier-tiff');
    }
    if(typeof this.props.allVideos !== 'undefined' && this.props.allVideos.length > 0) {
      this.playlistFilter(this.lng, this.props.allVideos, 'Fichiers');
    }
    if(this.typeTransfer === 'ce') {
      this.contourPx = getShopInfosInStorage() && getShopInfosInStorage().ce_px ?  getShopInfosInStorage().ce_px : 0;
    } else if (this.typeTransfer === 'w') {
      this.contourPx = getShopInfosInStorage() && getShopInfosInStorage().ce_px ?  getShopInfosInStorage().w_px : 0;
    }
  }

  componentWillUnmount(): void {
    window.removeEventListener("resize", () => { /** */ });
    window.removeEventListener("click", this.pageClick);
    this._isMounted = false;
  }

  componentDidUpdate(NextProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
    if(NextProps.i18n.language !== this.lng) {
      this.lng = NextProps.i18n.language;
      this.loadHtml(this.lng, 'preparer-mon-fichier-tiff');
    }

    if(NextProps.allVideos && (typeof this.state.videosFichiers === 'undefined' || this.state.videosFichiers === null )) {
      this.playlistFilter(this.lng, NextProps.allVideos, 'Fichiers');
    }
  }

  private pageClick(e: any) {
    const elt = e.path;
    if(elt && this.state.openPopover) {
      let isPopover = false;
      elt.forEach(function(item: any){
        if (item && item.classList && item.classList.contains('popover')) {
          isPopover = true;
        }
      });
      if(!isPopover) {
        this.setPopoverOpen();
      }
    }
  }

  private checkIfMobile() {
    if(window.innerWidth < 992 && !this.state.isMobile) {
      this.setState({
        isMobile: true
      });
    } else if(window.innerWidth > 992 && this.state.isMobile ) {
      this.setState({
        isMobile: false
      });
    }
  }


  private loadHtml(lng: string, namePage: string) {
    axios.get(`${window.location.origin}/html/${lng}/${namePage}.html`)
      .then((res) => {
        let content = res.data;
        const minSfc = this.props.product && this.props.product.a_partir_de_DT_data && this.props.product.a_partir_de_DT_data.surface ? this.props.product.a_partir_de_DT_data.surface : this.props.surfaceMin;
        content =  content.replace('CMinL', minSfc.toString().concat('cm²'));
        content =  content.replace('CMaxL', this.dimensions.centimetreMaxLargeur + ' x ' + this.dimensions.centimetreMaxHauteur + 'cm');
        this.setState({contentCaracteristiques: content});
      }).catch((err) => {
      console.error(err);
    });
  }

  private setPopoverOpen() {
    this.setState({openPopover: !this.state.openPopover});
  }

  handleOnFormSubmit(e: any) {
    e.preventDefault();
  }

  private handleOnFormChange(e: any) {
    const target: any = e.target;
    const name: any = target.name;
    const value: any = target.value;

    this.setState({
      ...this.state, [name]: value
    }, this.dimensionsValides);
  }

  private setColorsData(colorData: colorData) {
    this.setState({colorData: colorData, contourColor: `#${colorData.hexadecimal}`});
  }

  private handleOnPriceChange(data: any, defaultPrice: boolean) {
    if (this._isMounted && data !== undefined) {
      this.setState({
        prixTotal: data.pt,
        dateLivraison: data.date_livraison,
        defaultPrice: defaultPrice
      });
    }
  }

  private onUploadFile(fileName: string, creationId: string) {
    this.setState({
      creationId: creationId,
      file: fileName
    }, this.onUnlockDimensions);
  }

  private onUploadFileLoading(loading: boolean) {
    this.setState({
      loadingFile: loading
    });
  }

  private dimensionsValides() {
    const valide = ((this.state.dimensions.l * this.state.dimensions.h) >= 1) && ((this.state.dimensions.l * this.state.dimensions.h) <= 1120);
    this.setState({
      ...this.state, dimensionsValides: valide
    }, () => { this.setDataArticle(valide)});
  }

  private setDataArticle(valide: boolean) {
    if(valide) {
      const properties = {
        quantites: this.state.quantite,
        quantite: this.state.quantite,
        largeur: this.state.dimensions.l,
        hauteur: this.state.dimensions.h,
        article_id: this.state.article_id
      }
      this.setState({
        ...this.state, articleData: properties
      });
    }
  }

  private setDimensions(largeur: number, hauteur: number) {
    this.setState({
      dimensions: {l: largeur, h: hauteur},
    });
    if (this.state.file) {
      this.setState({
        disabled: true,
        unlockDimensions: true,
      }, this.dimensionsValides);
    }
  }

  private getFileInfos(params: fileInfos) {
    this.setState({
      fileInfos: params,
    });
  }

  private onDeleteFile() {
    this.reset();
  }

  private onUnlockNombreVisuels() {
    this.setState({
      unlockNbVisuels: true
    } , () => { this.scrollToId('validateQuantites')});
  }

  private onUnlockDimensions() {
    // @ts-ignore
    this.setState({
      unlockDimensions: true
    }, () => {this.scrollToId('validateDimensions')});
  }

  private scrollToId(element: string, reset: boolean = false, delay: number = 1000) {
    clearTimeout(this.timeoutId);
    if(this.state.isMobile && !reset) {
      const elementY = document.getElementById(element);
      if (elementY) {
        const goTO = elementY.getBoundingClientRect().top;
        this.timeoutId = setTimeout(function () {
          window.scrollTo({top: goTO, behavior: 'smooth'});
        }, delay);
      }
    } else if(reset) {
      const goTO = 0;
      window.scrollTo({top: goTO, behavior: 'smooth'});
    }
  }

  private reset() {
    this.setState({
      marquageId: 0,
      quantite: 0,
      dimensions: {l: 0, h: 0},
      price: 0,
      file: null,
      creationId: "",
      dimensionsValides: false,
      disabled: false,
      unlockNbVisuels: false,
      unlockDimensions: false,
      loadingFile: false,
      article_id: this.setArticleId(this.props.product),
      articleData: {}
    },() => { this.scrollToId('',true)});
  }

  private handleOnAddCartBtnClick() {
    createItems([{
      creation_id: this.state.creationId,
      quantite: this.state.quantite,
      dimensions: {
        0: {
          largeur_visuel: this.state.dimensions.l,
          hauteur_visuel: this.state.dimensions.h
        }
      },
      marquage_id: this.state.article_id === 488223 ? 2 : 3,
      article_id: this.state.article_id,
      cmjnData: {
        c: this.state.colorData?.c,
        m: this.state.colorData?.m,
        j: this.state.colorData?.j,
        n: this.state.colorData?.n,
        hexadecimal: this.state.colorData?.hexadecimal
      }
    }]);

    this.setState({
      quantiteAjoutee: this.state.quantite,
      openModalControl: false
    }, this.onOpenModalZoom);
    removeFileInLocaleStorage(this.state.creationId);
    this.reset();

  }



  private setTransfert(product: any) {
      const idArticle = Number(product?.couleurs[0]?.tailles[0]?.article_id);
      let typeTransfert = '';
      if(idArticle === 405637) {
        typeTransfert = 'c';
      } else if(idArticle === 405638) {
        typeTransfert = 'w';
      } else if(idArticle === 405639) {
        typeTransfert = 'ce';
      } else if(idArticle === this.DTF_ID) {
        typeTransfert = 'dtf';
      }
      return typeTransfert;
  }

  private setArticleId(product: any) {
    return product?.couleurs[0]?.tailles[0]?.article_id;
  }

  onOpenModalZoom = () => {
    if (!this.state.openZoom) { this.setState({openZoom: true}); }
  }

  onCloseModalZoom = () => {
    if (this.state.openZoom) { this.setState({openZoom: false, quantiteAjoutee: 0}); }
  }

  onOpenModalControl = () => {
    this.setState({openModalControl: !this.state.openModalControl});
  }

  onOpenModalVideo = (videoId: any) => {
    if (!this.state.openVideo) { this.setState({openVideo: true,videoOpenId : videoId}); }
  }
  onCloseModalVideo = () => {
    if (this.state.openVideo) { this.setState({openVideo: false, videoOpenId: ''}); }
  }

  onOpenModalSwitch = () => {
    this.setState({openModalSwitch: !this.state.openModalSwitch});
  }

  handleClickBtnAddToCart = (): void => {
    if (this.state.fileInfos?.UniversalImageToTiff && this.state.dimensionsUpdateNotSave) {
      this.setState({ openModalDimensionsNotSave: true });
    } else if (this.state.fileInfos?.UniversalImageToTiff) {
      this.onOpenModalControl();
    } else {
      this.handleOnAddCartBtnClick();
    }
  };

  private getMinimumQuantityForSurface(dimensions: { l: number, h: number }): number {
    if (!dimensions) {
      return 0;
    }
    return Math.ceil(this.surfaceSwitchMarquage / (dimensions.l * dimensions.h));
  }

  render() {
    if (this._isMounted) {
      const renderDateLivraisonEstimee = () => {
        if (this.state.dateLivraison && this.state.dateLivraison !== '0000-00-00') {
          const livraisonEstimee = moment(this.state.dateLivraison).format('dddd DD MMM');

          return (
            <>
              <Icons icon="local_shipping" size={24}
                     className={'mr-2'}/>{this.props.t('estimated_delivery')}&nbsp;{livraisonEstimee}
            </>
          );
        }
      };

      let surfaceIsOk = false;
      let conditionSwitch = false;
      const isDTF = this.state.article_id === this.DTF_ID;

      if(this.typeTransfer !== '') {
        const dimensionsValides = getShopInfosInStorage()?.dimensionsVisuel || {};
        surfaceIsOk = ((this.state.dimensions.l * this.state.dimensions.h) >= this.props.product.a_partir_de_DT_data.surface) && ((this.state.dimensions.l * this.state.dimensions.h) <= (dimensionsValides.centimetreMaxLargeur * dimensionsValides.centimetreMaxHauteur));
        surfaceIsOk = surfaceIsOk && (this.state.dimensions.l >= dimensionsValides.centimetreMinLargeur && this.state.dimensions.h >= dimensionsValides.centimetreMinHauteur);
        surfaceIsOk = surfaceIsOk && (this.state.dimensions.l <= dimensionsValides.centimetreMaxHauteur || this.state.dimensions.h <= dimensionsValides.centimetreMaxHauteur);
        surfaceIsOk = surfaceIsOk && ((this.state.dimensions.l <= dimensionsValides.centimetreMaxSiAutre && this.state.dimensions.h <= dimensionsValides.centimetreMaxHauteur)
          || (this.state.dimensions.l <= dimensionsValides.centimetreMaxHauteur && this.state.dimensions.h <= dimensionsValides.centimetreMaxSiAutre));

        const surfaceActuelle = this.state.dimensions && this.state.quantite * this.state.dimensions.l * this.state.dimensions.h;
        conditionSwitch = isDTF ? surfaceActuelle >= this.surfaceSwitchMarquage : surfaceActuelle < this.surfaceSwitchMarquage;        
      }

      let disabledAddToCart = this.state.quantite < 1 ||  this.state.quantite < this.quantiteMin || this.state.prixTotal === 0 || (this.typeTransfer === 'ce' && this.state.colorData === undefined);
      disabledAddToCart = this.typeTransfer !== '' ? !surfaceIsOk || disabledAddToCart : disabledAddToCart;
      
      const quantiteMinSwitch = isDTF ? this.getMinimumQuantityForSurface(this.state.dimensions) - 1 : this.getMinimumQuantityForSurface(this.state.dimensions);


      const articleId = this.props.product?.couleurs[0]?.tailles[0]?.article_id;
      const needColorPickr = this.typeTransfer !== '' && this.typeTransfer !== 'dtf';
      const showContour =  this.typeTransfer === 'ce' || this.typeTransfer === 'w' ;
      const pixelContourValue = 8*this.state.dpiWindow/400;
      const contourCss = showContour ? {filter: `drop-shadow(${pixelContourValue}px 0px 0px ${this.state.contourColor}) drop-shadow(-${pixelContourValue}px 0px 0px ${this.state.contourColor}) drop-shadow(0px ${pixelContourValue}px 0px ${this.state.contourColor})  drop-shadow(0px -${pixelContourValue}px 0px ${this.state.contourColor})`} : {};
      
      const renderModalSwitch = () => {
        if (!conditionSwitch || this.state.quantite  <= 0) {
          return null;
        }
      
        const link = <a href={isDTF ? "/c-transferts-serigraphiques-443" : "/p-dtf-19504"} className="btn-dt-primary mx-2 btn btn-secondary my-2">{this.props.t('modify_transfer_type')}</a>;
        const linkClose = <a onClick={this.onOpenModalSwitch} className="btn-dt-primary mx-2 btn btn-secondary my-2">{this.props.t('modify_quantity')}</a>;

        return (
          <Modal open={this.state.openModalSwitch} classNames={{modal: "zoomModalCart"}} onClose={this.onOpenModalSwitch} center>
              <div className="d-flex flex-column justify-content-between text-center align-items-center padding20">
                <span className="bold">{this.props.t('quantity_required_visual').replace('MINMAX', isDTF ? 'maximale' : 'minimale').replace('NB_PIECES', quantiteMinSwitch)}</span>
                <span className="padding20">{this.props.t('adapt_transfer_type')}</span>
                <div className="display-flex justify-content-between w-100">
                  <span>{link}</span>
                  <span>{linkClose}</span>
                </div>
              </div>
          </Modal>
        );
      }

      return (
        <>
          <Col className={'p-0'}>
            <div className={'bold border-black border-bottom mb-2 d-flex justify-content-between'}>
              <div>{this.props.t('send_my_file')}</div>
              <div className="pb-1">
                <Icons
                  icon="play_circle_filled"
                  size={25}
                  className={'black cursor-pointer'}
                  title={this.props.t('video')}
                  onClick={() => this.onOpenModalVideo(this.state.videosFichiers[0].id)}
                />
              </div>
            </div>
            <Form className={'form-cmd-dt'} onSubmit={this.handleOnFormSubmit}>
              <Row>
                <Col xs={12} md={12} className={`blocCommande mb-4 mb-md-0`}>
                  <FormGroup className={`position-relative mt-2 rounded justify-content-between align-items-center`}>
                      <Row>
                        <Col xs={12} md={this.state.file ? 12 : 6}>
                        <FormGroup className={' mb-4 mb-lg-0'}>
                            <UploadInput onUpload={this.onUploadFile} onUploadLoading={this.onUploadFileLoading}  transferType={this.typeTransfer} surfaceDefault={this.props.product.a_partir_de_DT_data.surface}
                                        setDimensions={this.setDimensions} isDejaUpload={this.state.file} articleId={articleId} getFileInfos={this.getFileInfos}
                                        onDelete={this.onDeleteFile} onDimensionsChange={(bool: boolean) => this.setState({ dimensionsUpdateNotSave: bool })}
                            />
                        </FormGroup>
                        </Col>
                        {!this.state.file && <Col xs={12} md={6}>
                          <div className="font14 mb-1 d-flex flex-column justify-content-center h-100 grey" dangerouslySetInnerHTML={{__html: this.state.contentCaracteristiques}}>
                          </div>
                        </Col>}
                      </Row>
                  </FormGroup>
                </Col>
                {needColorPickr &&
                  <Col xs={12} md={12} id={'validateColors'}>
                    <ColorsTextile typeTransfer={this.typeTransfer} lng={this.lng}  setColorsData={this.setColorsData} />
                  </Col>
                }
                <Col xs={12} md={12} id={'validateQuantites'}>
                  <div className="bold border-black border-bottom my-2 d-flex justify-content-between">
                    <div>{this.props.t('amount_of_transfers')}</div>
                    <div className="pb-1">
                      <Icons
                        icon="info"
                        size={25}
                        className={'black cursor-pointer'}
                        onClick={() => this.setState({showModalTarifs: true})}
                      />
                    </div>
                  </div>
                  <FormGroup
                    className={`d-flex position-relative flex-column rounded mb-0  ${this.state.unlockDimensions && this.state.unlockNbVisuels ? 'shadow  border-success' : ''}`}>
                      <div className={'d-flex py-1 h-100'}>
                        <div
                          className={'d-flex py-1 pb-md-4 pt-md-0 flex-grow-1 flex-column '}>
                          <NombreInput
                            showModal={this.state.showModalTarifs}
                            onChange={this.handleOnFormChange}
                            disabled={this.state.file == null}
                            fileUploaded={this.state.file != null}
                            productId={this.props.product.id}
                            qtepriceFrom={this.props.product.a_partir_de_DT_data}
                            dimensions={this.state.dimensions}
                            quantite={this.state.quantite}
                            onCloseModalTarifs={() => this.setState({showModalTarifs: false})}
                            surfaceSwitchMarquage={this.surfaceSwitchMarquage}
                          />
                        </div>
                      </div>
                  </FormGroup>
                  <Row className={`align-items-center`}>
                    <Col xs={12}>
                    <div className={'bold  border-black border-bottom  mb-2 '}>{this.props.t('total')}</div>
                    </Col>
                    <Col xs={12} md={6} className={`${disabledAddToCart ? 'opac40' : '' }`}>
                      <FormGroup>
                      <PriceArticle productId={15542} isTransfert={true} articleData={this.state.articleData}  defaultIdArticle={this.state.article_id} fileUploaded={this.state.file != null} qtepriceFrom={this.props.product.a_partir_de_DT_data}
                                    onPriceChange={this.handleOnPriceChange}/>
                    </FormGroup>
                    </Col><Col className={`${disabledAddToCart ? 'opac40' : '' }`}>
                    <FormGroup className={'flex-grow-1'}>
                      {renderDateLivraisonEstimee()}
                      <Button block id={"add_btn"} onClick={conditionSwitch ? this.onOpenModalSwitch : this.handleClickBtnAddToCart}
                              disabled={disabledAddToCart}
                              className={" font20 w100 btn-dt-primary"}>{this.props.t('add_to_cart')}</Button>
                    </FormGroup>
                    </Col>
                    {renderModalSwitch()}
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
            <Modal open={this.state.openZoom} onClose={this.onCloseModalZoom} classNames={{modal: "zoomModalCart"}}
                 center>
            <div className={'p-md-5'}>
              <p className={'bold text-center'}>
                <Icons icon="done" size={26}
                       className={'puce mr-2 green'}/> {this.state.quantiteAjoutee} {this.props.t('transfers_have_been_added_to_your_cart')}.
              </p>
              <p className={'py-3 text-center'}>{this.props.t('what_do_you_want_to_do')}</p>
              <div className={'d-flex'}>
                <button className={'btn btn-dt-secondary mr-4'}
                        onClick={this.onCloseModalZoom}>{this.props.t('continue_shopping')}</button>
                <a href={`/${this.lng}/cart`}>
                  <button id={"finalize_btn"} className={'btn btn-dt-primary ml-4 cursor-pointer'} onClick={this.onCloseModalZoom}>
                    <Icons icon="cart" size={26} className={`shortIconMenu color mr-2 ml-2 white`}/>
                    {this.props.t('finalize_my_order')}
                  </button>
                </a>
              </div>
            </div>
          </Modal>
          {this.state.videoOpenId && this.state.videoOpenId != '' &&
          <Modal open={this.state.openVideo} onClose={this.onCloseModalVideo} classNames={{modal: "zoomVideo"}}
                 center>
            <div className={"embed-responsive embed-responsive-16by9"}>
              <iframe className={"embed-responsive-item"}
                    src={`https://www.youtube-nocookie.com/embed/${this.state.videoOpenId}?controls=1&rel=0&showinfo=0&modestbranding=1&iv_load_policy=3`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
            </div>
          </Modal>
          }
          <ModalDimensionsNotSave
            show={this.state.openModalDimensionsNotSave}
            fileInfos={this.state.fileInfos}
            onCancel={() => this.setState({ openModalDimensionsNotSave: false })}
            onContinue={() => {
              this.setState({ openModalDimensionsNotSave: false });
              this.onOpenModalControl();
            }}
          />
          <ModalControl openModalControl={this.state.openModalControl} onOpenModalControl={this.onOpenModalControl}
                        fileInfos={this.state.fileInfos} typeTransfer={this.typeTransfer} contourCss={contourCss}
                        handleOnAddCartBtnClick={this.handleOnAddCartBtnClick} colorData={this.state.colorData}
          />
        </>
      );
    } else {
      return null;
    }
  }
}
export default withTranslation('common')(withHostApi(SmallOrderTable));
